<template>
  <div :class="{ 'vue-treeselect_hasRequiredError': hasRequiredError }">
    <tree-select
      v-if="options"
      :disable-branch-nodes="true"
      :clearable="clearable"
      :searchable="false"
      :options="options"
      placeholder="Select indication"
      v-model="localBranchId"
    />
    <span v-if="hasRequiredError" class="vue-treeselect__error-msg"
      >Branch is required</span
    >
  </div>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { HttpHandler } from "@/http/HttpHandler";
import { DiseaseTreeBranchModel } from "@/entities/diseaseParameters/DiseaseTreeBranchModel";
import { DiseaseTreeLeafModel } from "@/entities/diseaseParameters/DiseaseTreeLeafModel";
import store from "@/store/index"; 

// @ts-ignore
import { Treeselect as TreeSelect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: {
    TreeSelect
  }
})
export default class AppDiseaseTreeSelector extends Vue {
  private options:
    | (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[]
    | null = null;

  @Prop()
  branchId!: number | null;
  private localBranchId: number | null = this.branchId;
  
  @Prop({ type: Boolean, default: false })
  clearable!: boolean;

  @Prop({ type: Boolean, default: false })
  hasRequiredError!: boolean;

  @Prop({ type: Boolean, default: false })
  onlyAnswered!: boolean;

  async created() {
    const httpHandler = new HttpHandler(store);
    const tree = await httpHandler.getDiseaseTree(this.onlyAnswered);
    if (tree) {
      this.options = tree.toDiseaseTreeItemModel();
    }
  }

  @Watch("localBranchId")
  onLocalBranchIdChanged() {
    this.$emit("update:branchId", this.localBranchId);
  }
  @Watch("branchId")
  onBranchIdChanged() {
    this.localBranchId = this.branchId;
  }
}
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/_mixins.scss";

.vue-treeselect {
  $this: &;
  border-radius: 0.25rem;

  &--open &__control {
    border-color: #80bdff !important;
  }

  &__control {
    height: calc(1.5em + 0.75rem + 2px);
    @include font-size($input-font-size);
    font-weight: $input-font-weight;
    line-height: $input-line-height;
    color: $input-color;
    vertical-align: middle;

    &-arrow-container {
      svg {
        display: none;
      }

      background: #fff
        url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
        no-repeat right 0.75rem center/8px 10px;
    }
  }

  &__menu {
    padding: 0 !important;
    left: 1px;
    width: calc(100% - 2px);
    border-radius: 0 !important;
    border-color: #a0a0a0 !important;
  }

  &__option--highlight {
    background: #0078d7;
    color: #fff;
  }

  &__option {
    height: 32px !important;
  }

  &__option--highlight &__option-arrow {
    color: #fff !important;
  }

  &--focused {
    color: $gray-700 !important;
    background-color: #fff !important;
    border-color: #80bdff !important;
    outline: 0 !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  }

  &_hasRequiredError {
    #{$this}__control {
      border-color: $red !important;
    }

    #{$this}__control-arrow-container {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right calc(0.21rem) center;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }
  }

  &__error-msg {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: $red;
  }
}
</style>
